module.exports = __webpack_public_path__ + "img/promo-sale-offer-campaign.6c350730.jpg";